import React from 'react';
import { MapPinIcon, TrendingUpIcon, CoffeeIcon } from 'lucide-react';
export function WhyCremorne() {
  return <section className="bg-brand-dark py-16 md:py-32 px-5 md:px-12 lg:px-24 border-y border-brand-grey/20" data-id="element-86">
      <div className="max-w-7xl mx-auto" data-id="element-87">
        <div className="mb-12 md:mb-24" data-id="element-88">
          <p className="font-mono uppercase tracking-label text-brand-grey text-xs mb-5 md:mb-6" data-id="element-89">
            THE LOCATION.
          </p>
          <h2 className="font-display uppercase text-brand-white text-3xl md:text-6xl leading-[0.9]" data-id="element-90">
            <span className="block" data-id="element-91">MELBOURNE'S PREMIER</span>
            <span className="block" data-id="element-92">CREATIVE PRECINCT.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-0" data-id="element-93">
          {/* Column 1 */}
          <div className="flex flex-col md:pr-12 md:border-r md:border-brand-grey/30 border-b border-brand-gold/20 md:border-b-0 pb-10 md:pb-0" data-id="element-94">
            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-95">
              <MapPinIcon className="w-4 h-4 text-brand-gold" strokeWidth={1.5} data-id="element-96" />
              <h3 className="font-mono tracking-label text-brand-gold text-xs uppercase" data-id="element-97">
                LOCATION
              </h3>
            </div>
            <p className="font-body font-light text-brand-white/70 text-sm leading-relaxed" data-id="element-98">
              Situated just 3km from Melbourne's CBD, Cremorne offers unmatched
              connectivity. Minutes from Richmond station, tram networks, and
              CityLink, with immediate access to the Yarra River corridor and
              inner-city amenity.
            </p>
          </div>

          {/* Column 2 */}
          <div className="flex flex-col md:px-12 md:border-r md:border-brand-grey/30 border-b border-brand-gold/20 md:border-b-0 pb-10 md:pb-0" data-id="element-99">
            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-100">
              <TrendingUpIcon className="w-4 h-4 text-brand-gold" strokeWidth={1.5} data-id="element-101" />
              <h3 className="font-mono tracking-label text-brand-gold text-xs uppercase" data-id="element-102">
                DEMAND
              </h3>
            </div>
            <p className="font-body font-light text-brand-white/70 text-sm leading-relaxed" data-id="element-103">
              Cremorne has emerged as Melbourne's tightest commercial submarket.
              Vacancy rates sit well below the metropolitan average, driven by
              sustained demand from technology, media, and creative tenants
              seeking quality fitted space.
            </p>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col md:pl-12" data-id="element-104">
            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-105">
              <CoffeeIcon className="w-4 h-4 text-brand-gold" strokeWidth={1.5} data-id="element-106" />
              <h3 className="font-mono tracking-label text-brand-gold text-xs uppercase" data-id="element-107">
                LIFESTYLE
              </h3>
            </div>
            <p className="font-body font-light text-brand-white/70 text-sm leading-relaxed" data-id="element-108">
              Church Street and Swan Street provide a curated mix of dining,
              retail, and specialty coffee. The precinct is one of Melbourne's
              most walkable and cyclable neighbourhoods, attracting a young
              professional workforce.
            </p>
          </div>
        </div>
      </div>
    </section>;
}